module.exports = __webpack_public_path__ + "static/media/intro.57561dfc.jpg";